import { isDevelopmentEnv } from "./enviroments";


export const isComplexEventEnabled = isDevelopmentEnv;
export const isOtherUserProfileEnabled = false;
// export const isMockStreamInVideoPlayerEnabled = isDevelopmentEnv;
